import { useParams } from 'react-router';

import { QuizzesStatus } from "../../../../../types/working-model";
import { useTranslate } from '../../../../../i18n/useTranslationModules';
import { isRtlLanguage } from '../../../../../utils/utils';
import { ParamsProps } from '../../../../live-event/live-event';
import { OptionalComponent } from '../../../../../utils/optional-component';
import Icon, { COLORS, ICONS } from '../../../../general-ui/icon';

interface QuizzesStatusProps {
	quizStatus: QuizzesStatus;
	retake: () => void;
	canRetake?: boolean;
}
const QuizQuestionEndScreen: React.FC<QuizzesStatusProps> = ({ quizStatus, canRetake, retake }) => {
	const { t } = useTranslate("session");
	const { language } = useParams<ParamsProps>();


	if (!quizStatus) { return <></>; }

	const calculateFinishedRatio = (quizOverall: QuizzesStatus) => {
		if (quizOverall) {
			return ` ${(quizOverall.correctAnswers)}/${quizOverall.totalAnswered} `;
		}
	};

	const completionText =
		!isRtlLanguage(language) ?
			[`You’ve finished the quiz and answered`, `quiz questions correctly`] :
			[`quiz questions correctly`, `You’ve finished the quiz and answered`];

	// isRtlLanguage
	return (
		<div className="quiz-completion">
			<div className="party-icon">{quizStatus.passed ? '🎉' : '😌'}</div>
			<div className="completion-status-container">
				<div className="completion-status">{
					quizStatus.passed ?
						t(`Congratulations`) || "Congratulations"
						:
						t(`Oops!`) || "Oops!"}
				</div>

				<div className="completion-status-subtext">
					{t(completionText[0])} {/* IN ENGLISH: You’ve finished the quiz and answered */}
					<b>{calculateFinishedRatio(quizStatus)}</b>
					{t(completionText[1])} {/* IN ENGLISH: quiz questions correctly */}
				</div>
			</div>
			<OptionalComponent display={!!canRetake}>
				<div className='retake-container'>
					<button className='retake-button' onClick={() => retake()}>
						<Icon name={ICONS.REFRESH_TRANSPARENT} size={20} color={COLORS.DEFAULT} />
						<span>{t(`Retake`) ?? 'Retake'}</span>
					</button>
				</div>
			</OptionalComponent>
		</div>
	);
};

export default QuizQuestionEndScreen;